<template>
  <div class="project-one-header text-center">
    <h2 qaid="project-one-header-title-text" class="mb-2 heading heading--lg" v-html="title"></h2>
    <p qaid="project-one-header-body-text" class="mx-auto text-md mb-3 md:w-4/5 lg:mb-4 lg:w-3/5" v-html="message"></p>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.project-one-header {
  margin-top: 3rem;

  @screen lg {
    margin-top: 4rem;
  }
}
</style>
